// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { AlertconditionState } from "@/types/alertcondition";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Alertcondition } from "@/models/alertcondition";

const state: AlertconditionState = {
  single: new Alertcondition(),
  pagination: new Pagination(),
};

export const alertcondition: Module<AlertconditionState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
